module.exports = __webpack_public_path__ + "img/engine.10fa2d41.svg";